import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerSummaryMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('summary', locale)
}
